import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SelectMunicipalityComponent } from './pages/select-municipality/select-municipality.component';
import { MissedServiceComponent } from './components/missed-service/missed-service.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'select-municipality',
    pathMatch: 'full',
  },
  {
    path: 'select-municipality',
    component: SelectMunicipalityComponent,
    data: {
      title: 'Select Client',
      showBackButton: true,
      hideSupportButtons: true,
      backButtonUrl: '/support',
      styleClass: 'select-municipality',
    },
  },
  {
    path: ':municipalityId/:caseTypeId',
    component: MissedServiceComponent,
    data: {
      title: 'RTS Support',
      showBackButton: true,
      hideSupportButtons: true,
      backButtonUrl: ['/muni-support', 'select-municipality'],
      heroImageCol: 3,
      styleClass: 'createTicket',
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SupportPublicRoutingModule {}
